import { render } from "./RateProduct.vue?vue&type=template&id=42aae831"
import script from "./RateProduct.vue?vue&type=script&lang=js"
export * from "./RateProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__